<template>
   <div class="task-calendar-page">
            <div class="page-content">
                <div class="calendar-card">
                    <div class="d-flex align-items-center mb-4" style="gap: 12px;">
                        <div>
                            <el-select v-model="form.type" placeholder="Chon loại tasks" clearable>
                                <el-option
                                    v-for="item in typeTask"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value" >
                                </el-option>
                            </el-select>
                        </div>

                        <div>
                            <el-select v-model="form.status" placeholder="Chon trạng thái tasks" clearable>
                                <el-option
                                    v-for="item in statusTasks"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>

                    </div>
                    <div class="my-cal-wrap">
                        <div class="my-cal-title position-absolute" style="top: 94px; font-size: 14px; font-weight:500">{{ calendarTitle }}</div>
                        <el-calendar v-model="currentDate">
                            <template slot="dateCell" slot-scope="{ date, data }">
                                <div
                                    class="calendar-cell"
                                    :class="{
                            'has-task': getDaySummary(data.day).total,
                            'is-today': isToday(data.day),
                            'is-selected': isSelectedDay(data.day),
                          }"
                                    @click="selectDay(data.day)">

                                    <div class="cell-header">
                                        <span class="cell-date">{{ date.getDate() }}</span>

                                        <span
                                            v-if="getDaySummary(data.day).total"
                                            class="cell-badge"
                                        >
                                  {{ getDaySummary(data.day).total }} tasks
                                </span>
                                    </div>

                                    <div
                                        v-if="getDaySummary(data.day).total"
                                        class="cell-status-list">

                                        <div
                                            v-if="getDaySummary(data.day).todo"
                                            class="status-item"
                                        >
                                            <span class="status-dot status-todo"></span>
                                            <span class="status-label">Chưa xử lý</span>
                                            <span class="status-count">{{ getDaySummary(data.day).todo }}</span>
                                        </div>
                                        <div
                                            v-if="getDaySummary(data.day).doing"
                                            class="status-item"
                                        >
                                            <span class="status-dot status-doing"></span>
                                            <span class="status-label">Đang xử lý</span>
                                            <span class="status-count">{{ getDaySummary(data.day).doing }}</span>
                                        </div>
                                        <div
                                            v-if="getDaySummary(data.day).done"
                                            class="status-item"
                                        >
                                            <span class="status-dot status-done"></span>
                                            <span class="status-label">Hoàn thành</span>
                                            <span class="status-count">{{ getDaySummary(data.day).done }}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-calendar>
                    </div>

                </div>

                <div class="side-panel">
                    <div class="side-header d-flex justify-content-between justify-space-between mb-2">
                        <div class="side-title mb-2">
                            Nhiệm vụ ngày {{ formatDisplayDate(selectedDay || todayKey) }}
                        </div>

                        <div class="d-flex align-items-center" style="gap: 5px;">
                            <div class="cursor-pointer">
                                <el-tooltip
                                    class="item cursor-pointer"
                                    effect="dark"
                                    content="Tìm theo tháng"
                                    placement="top-start">
                                    <i
                                        class="el-icon-date cursor-pointer"
                                        style="font-size: 24px; color: #10b981;"
                                        @click="openMonthPicker"
                                    ></i>
                                </el-tooltip>
                            </div>

                            <div class="cursor-pointer">
                                <el-date-picker
                                    ref="monthPicker"
                                    v-model="selectedMonth"
                                    type="month"
                                    placeholder="Chọn tháng"
                                    format="MM/yyyy"
                                    value-format="yyyy-MM"
                                    :clearable="false"
                                    :editable="false"
                                    append-to-body
                                    class="invisible-picker"
                                    @change="onMonthChange"
                                />
                            </div>

                            <el-tooltip class="item" effect="dark" content="Tạo task việc" placement="top-start">
                                <i
                                    class="el-icon-edit-outline cursor-pointer"
                                    style="font-size: 24px; color: #624BA6;"
                                    @click="createTaskVisible = true"
                                ></i>
                            </el-tooltip>
                        </div>
                    </div>

                    <div class="side-stats" v-if="selectedSummary.total">
                        <div class="stat-card">
                            <div class="stat-label text-white">
                                <span class="status-dot status-todo"></span>
                                Chưa xử lý
                            </div>
                            <div class="stat-number text-white">{{ selectedSummary.todo }}</div>
                        </div>
                        <div class="stat-card">
                            <div class="stat-label text-white">
                                <span class="status-dot status-doing"></span>
                                Đang xử lý
                            </div>
                            <div class="stat-number text-white">{{ selectedSummary.doing }}</div>
                        </div>
                        <div class="stat-card">
                            <div class="stat-label text-white">
                                <span class="status-dot status-done"></span>
                                Hoàn thành
                            </div>
                            <div class="stat-number text-white">{{ selectedSummary.done }}</div>
                        </div>
                    </div>

                    <div class="task-list" v-if="selectedTasks.length" style="overflow: scroll; max-height: 100vh; min-height: 134px">
                        <div
                            v-for="task in selectedTasks"
                            :key="task.id"
                            class="task-item"
                        >
                            <div class="task-main cursor-pointer" @click="showTaskDetail(task)">
                                <div class="task-title" v-if="task.type === 1 && task.customer">
                                    Xử lý khách hàng: {{ task.customer.name }} - {{ task.customer.phone }}
                                </div>

                                <div v-else-if="task.type === 2" class="task-title cursor-pointer">
                                    Task việc đội nhóm
                                </div>
                                <div v-else class="task-title cursor-pointer">
                                    Task việc cá nhân
                                </div>
                                <div class="task-meta">
                                <span class="task-time">
                                  Deadline: {{ formatTime(task.deadline) }} |
                                </span>

                                    <span v-if="task.created_user" class="task-assigned">
                                   Người giao: {{ task.created_user.name }}
                                </span>

                                    <span v-if="task.get_sale" class="task-assigned">
                                    người xử lý: {{ task.get_sale.name }}
                                </span>
                                </div>
                            </div>

                            <el-tag
                                size="mini"
                                :type="statusTagType(task.status)"
                                class="task-status-tag"
                            >
                                {{ statusLabel(task.status) }}
                            </el-tag>
                        </div>
                    </div>

                    <div class="empty-state text-center" v-else>
                        <p>Chưa có task nào trong ngày này.</p>
                    </div>

                    <div class="side-footer" style="position: sticky; bottom: 10px">
                        Thành công được tạo nên từ những nỗ lực nhỏ<br />
                        kiên trì lặp lại mỗi ngày! 🌱
                    </div>
                </div>
            </div>

            <el-dialog title="Tạo task việc" width="60%" class="responsive" :visible.sync="createTaskVisible" :show-close="false">
                <create-task-dialog :is_show="createTaskVisible" @close="emitCloseCreateTask()" @closeDialog="createTaskVisible=false"/>
            </el-dialog>

            <el-dialog
                :title="taskDetail.result ?'Sửa báo cáo tiến độ công việc' : 'Báo cáo tiến độ công việc'"
                width="60%"
                class="responsive"
                append-to-body
                :visible.sync="dialogHandleInputResult"
            >
                <create-input-result :is_show="dialogHandleInputResult" :task="taskDetail" @close="dialogHandleInputResult=false;emitCloseCreateTask()" />
            </el-dialog>

            <el-dialog
                title="Sửa nội dung task"
                width="60%"
                class="responsive"
                append-to-body
                :visible.sync="dialogUpdateContentTaskVisible"
            >
                <update-content-task :is_show="dialogUpdateContentTaskVisible" :task="taskDetail" @close="dialogUpdateContentTaskVisible=false; emitCloseCreateTask()" />
            </el-dialog>

            <el-dialog
                title="Nội dung chi tiết task"
                :visible.sync="dialogTaskDetailVisible"
                width="70%"
                top="10vh"
                style="border-radius: 12px; max-width: 90vw;"
                custom-class="task-detail-dialog"
                :close-on-click-modal="false"
                :show-close="false"
            >
                <hr>
                <div class="d-flex justify-content-end mb-2">
                    <el-dropdown @command="handleDropdownCommand">
                        <el-button type="primary" size="mini">
                            Hành động<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="this.taskDetail.status !== 3 && !this.taskDetail.result" command="thanh_pham">Nhập thành phẩm</el-dropdown-item>
                            <el-dropdown-item v-if="this.taskDetail.status !== 3 && this.taskDetail.result" command="thanh_pham">Sửa thành phẩm</el-dropdown-item>
                            <el-dropdown-item v-if="this.taskDetail.status !== 3" command="sua_noi_dung">Sửa nội dung</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="task-detail-label mb-2">Nội dung task:</div>

                <div class="task-detail-wrapper" style="background: rgb(238 240 245); padding: 16px; border-radius: 8px; max-height: 25vh; min-height: 20vh; overflow-y: auto;">
                    <div
                        style="word-break: break-word;"
                        class="task-detail-body"
                        v-html="taskDetail.task_content"
                    ></div>
                </div>
                <div v-if="taskDetail.result">
                    <hr class="mt-4">
                    <div class="task-detail-label mb-2">Nội dung thành phẩm:</div>
                    <div v-if="taskDetail.result" class="mt-2" style="background: rgb(238 240 245); padding: 16px; border-radius: 8px; max-height: 20vh; min-height: 5vh; overflow-y: auto;">
                        <div class="" v-html="taskDetail.result"></div>
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button size="mini" type="info" @click="dialogTaskDetailVisible = false">Đóng</el-button>
                    <el-button v-if="this.taskDetail?.customer" size="mini" type="primary" @click="switchPageCustomer">Chi tiết khách hàng</el-button>
                    <el-button v-if="[3,2].includes(this.taskDetail.type) && this.taskDetail.status ===  1" size="mini" @click="changeStatusTask(2)" type="warning">Đang xử lý</el-button>
                    <el-button v-if="[3,2].includes(this.taskDetail.type) && [1,2].includes(this.taskDetail.status)" @click="changeStatusTask(3)" size="mini" type="success">Hoàn thành</el-button>
                </div>
            </el-dialog>
        </div>
</template>
<script>

import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
import {CHANGE_STATUS_TASK, GET_TASK_BY_SALE} from "../../../core/services/store/customer/customer.module";
import {mapGetters} from "vuex";
import CreateTaskDialog from "./compoment/createTaskDialog.vue";
import CreateInputResult from "./compoment/createInputResultDialog.vue";
import UpdateContentTask from "./compoment/updateContentTask.vue";

export default {
    name: 'calendarTask',
    components: {UpdateContentTask, CreateInputResult, CreateTaskDialog},
    data () {
        const today = this.toDateKey(new Date())

        return {
            form: {
               type: '',
               status: '',
            },
            currentDate: new Date(),
            selectedDay: null,
            todayKey: today,
            tasks: [],
            dialogTaskDetailVisible:false,
            createTaskVisible: false,
            dialogHandleInputResult: false,
            dialogUpdateContentTaskVisible: false,
            taskDetail: '',
            selectedMonth: null,

            currentMonthKey: null,
            lastRangeKey: null,
            typeTask: [
                { value: 1, label: 'Khách hàng' },
                { value: 2, label: 'Đội nhóm' },
                { value: 3, label: 'Cá nhân' },
            ],
            statusTasks: [
                { value: 1, label: 'Chưa xử lý' },
                { value: 2, label: 'Đang xử lý' },
                { value: 3, label: 'Hoàn thành' },
            ]
        }
    },
    watch: {
        currentDate(newVal, oldVal) {
            const d = new Date(newVal);
            const monthKey = `${d.getFullYear()}-${d.getMonth()}`;

            if (monthKey !== this.currentMonthKey) {
                this.currentMonthKey = monthKey;

                const range = this.getMonthRange(d);
                this.getListTaskBySale(range);
            }

            this.selectedDay = this.toDateKey(d);
        },

        'form.type' () {
            this.reloadTasksByFilter()
        },
        'form.status' () {
            this.reloadTasksByFilter()
        },
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Task việc nhân sự", icon:'far fa-user'}
        ]);

        this.selectedDay = this.todayKey

        const range = this.getMonthRange(this.currentDate);
        const d = this.currentDate;
        this.currentMonthKey = `${d.getFullYear()}-${d.getMonth()}`;

        this.getListTaskBySale(range);

        const main = document.getElementById('js-page-content');
        if (main && !main.classList.contains('task-calendar-main-bg')) {
            main.classList.add('task-calendar-main-bg');
        }
    },

    beforeDestroy() {
        const main = document.getElementById('js-page-content');
        if (main) main.classList.remove('task-calendar-main-bg');
    },
    beforeRouteLeave(to, from, next) {
        const main = document.getElementById('js-page-content');
        if (main) main.classList.remove('task-calendar-main-bg');
        next();
    },

    computed: {
        ...mapGetters(["currentUser"]),

        tasksByDay () {
            const map = {}
            this.tasks.forEach(task => {
                const key = this.toDateKey(task.deadline)
                if (!map[key]) {
                    map[key] = { todo: 0, doing: 0, done: 0, list: [] }
                }

                const statusKey = this.statusKey(task.status)
                if (statusKey && map[key][statusKey] !== undefined) {
                    map[key][statusKey]++
                }

                map[key].list.push(task)
            })
            return map
        },
        selectedSummary () {
            const key = this.selectedDay || this.todayKey
            return this.getDaySummary(key)
        },

        selectedTasks () {
            const key = this.selectedDay || this.todayKey
            const record = this.tasksByDay[key]
            return record ? record.list : []
        },

        calendarTitle() {
            const d = new Date(this.currentDate)
            return `Tháng ${d.getMonth() + 1} Năm ${d.getFullYear()}`
        },
    },
    methods: {
        getMonthRange(date) {
            const d = new Date(date);
            const y = d.getFullYear();
            const m = d.getMonth();
            const monthStr = String(m + 1).padStart(2, '0');
            const start = `${y}-${monthStr}-01`;
            const lastDay = new Date(y, m + 1, 0).getDate();
            const end = `${y}-${monthStr}-${String(lastDay).padStart(2, '0')}`;
            return { start, end };
        },
        go(action) {
            this.$refs.cal && this.$refs.cal.selectDate(action)
        },
        getListTaskBySale(range) {
            const { start, end } = range || this.getMonthRange(this.currentDate);
            const rangeKey = `${start}_${end}`;

            if (this.lastRangeKey === rangeKey) {
                return;
            }
            this.lastRangeKey = rangeKey;

            const payload = {
                type: this.form.type,
                status: this.form.status,
                user_id: this.currentUser.id,
                start_date: start,
                end_date: end
            };

            this.$store.dispatch(GET_TASK_BY_SALE, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.tasks = response.data;
                    }
                });
        },

        toDateKey (value) {
            const d = new Date(value)
            const y = d.getFullYear()
            const m = String(d.getMonth() + 1).padStart(2, '0')
            const day = String(d.getDate()).padStart(2, '0')
            return `${y}-${m}-${day}`
        },

        getDaySummary (dayKey) {
            const s = this.tasksByDay[dayKey] || { todo: 0, doing: 0, done: 0, list: [] }
            return {
                ...s,
                total: (s.todo || 0) + (s.doing || 0) + (s.done || 0)
            }
        },

        isToday (dayKey) {
            return dayKey === this.todayKey
        },

        isSelectedDay (dayKey) {
            return this.selectedDay === dayKey
        },

        selectDay (dayKey) {
            this.selectedDay = dayKey
        },

        formatDisplayDate (dayKey) {
            const [y, m, d] = dayKey.split('-')
            return `${d}/${m}/${y}`
        },

        formatTime (deadline) {
            const d = new Date(deadline)
            const h = String(d.getHours()).padStart(2, '0')
            const m = String(d.getMinutes()).padStart(2, '0')
            return `${h}:${m}`
        },

        statusKey (status) {
            if (status === 1) return 'todo'
            if (status === 2) return 'doing'
            if (status === 3) return 'done'
            return null
        },

        statusLabel (status) {
            if (status === 1) return 'Chưa xử lý'
            if (status === 2) return 'Đang xử lý'
            if (status === 3) return 'Hoàn thành'
            return 'Không rõ'
        },

        statusTagType (status) {
            if (status === 1) return 'warning'
            if (status === 2) return 'info'
            if (status === 3) return 'success'
            return ''
        },

        showTaskDetail(item) {
            this.taskDetail = item;
            this.dialogTaskDetailVisible = true;
        },

        switchPageCustomer() {
            const phone = this.taskDetail?.customer?.phone;
            const basePath = '/customer/list';

            if (!this.$router || typeof this.$router.push !== 'function') {
                const params = new URLSearchParams();

                if (phone) {
                    params.set('search', phone);
                }

                const queryString = params.toString();
                window.location.href = queryString ? `${basePath}?${queryString}` : basePath;
                return;
            }

            const query = {
                ...(this.$route?.query || {}),
            };

            if (phone) {
                query.search = phone;
            }

            this.$router.push({
                path: basePath,
                query,
            }).catch(() => {});
        },

        emitCloseCreateTask() {
            this.lastRangeKey = null;
            this.clearForm();
            const range = this.getMonthRange(this.currentDate);
            const { start, end } = range || this.getMonthRange(this.currentDate);
            const payload = {
                user_id: this.currentUser.id,
                start_date: start,
                end_date: end
            };
            this.$store.dispatch(GET_TASK_BY_SALE, payload)
                .then((response) => {
                    if (response.status === 422) {
                        this.$message({type: 'warning', message: `${response.message}`, showClose: true});
                    } else {
                        this.tasks = response.data;
                        this.createTaskVisible = false;
                    }
            });
        },

        changeStatusTask(type) {
            const task = this.taskDetail;
            const payload = {
                customer_id: task.customer_id,
                task_id: task.id,
                status: type,
                type: 2
            };

            this.$store.dispatch(CHANGE_STATUS_TASK, payload)
                .then((res) => {
                    if (res.status === 422) {
                        this.$message({type: 'warning', message: `${res.message}`, showClose: true})
                        return
                    }

                    const target = this.tasks.find(item => item.id === task.id);
                    if (target) {
                        target.status = type;
                    }

                    this.$notify({
                        title: 'Thành công!',
                        message: `${res.message}`,
                        type: 'success'
                    });
                    this.dialogTaskDetailVisible = false;
                });
        },

        openMonthPicker() {
            const picker = this.$refs.monthPicker;
            if (!picker) return;

            if (typeof picker.showPicker === 'function') {
                picker.showPicker();
            } else if (typeof picker.focus === 'function') {
                picker.focus();
            }
        },

        onMonthChange(month) {
            if (!month) return;
            const [y, m] = month.split('-');
            const date = new Date(y, Number(m) - 1, 1);

            this.currentDate = date;
        },

        handleDropdownCommand(command) {
            if (command === 'thanh_pham') {
              this.dialogTaskDetailVisible = false;
              this.dialogHandleInputResult = true;
            }

            if (command === 'sua_noi_dung') {
                this.dialogTaskDetailVisible = false;
                this.dialogUpdateContentTaskVisible = true;
            }
        },

        reloadTasksByFilter () {
            this.lastRangeKey = null

            const range = this.getMonthRange(this.currentDate)
            this.getListTaskBySale(range)
        },

        clearForm() {
            this.form = {
                status: '',
                type: '',
            };

        }
    },
}
</script>

<style scoped>
.invisible-picker {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

.task-calendar-page {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-height: 100vh;
}

.page-content {
    display: grid;
    grid-template-columns: minmax(0, 2.7fr) minmax(320px, 1fr);
    gap: 16px;
    padding: 0;
}

/deep/ .el-calendar-table .el-calendar-day {
    height: 92px !important;
    padding: 0 4px;
}

/* CALENDAR CARD */
.calendar-card {
    background: #ffffff;
    border-radius: 20px;
    padding: 16px 20px 20px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}

/* custom cell */
.calendar-cell {
    padding: 6px;
    margin-top: 11px;
    border-radius: 10px;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background-color: #ffffff;
    border: 1px solid transparent;
}

/deep/ td.current:hover,
.calendar-cell:hover {
    background: #f3f4ff;
    cursor: pointer;
}
.calendar-cell.has-task {
    background: #eff2f5;
}
.calendar-cell.is-today {
    border-color: #a6a8a8;
}
.calendar-cell.is-selected {
    border-color: #6f96e8;
    background: #e5edff;
}

.cell-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.cell-date {
    font-weight: 600;
    font-size: 13px;
    color: #111827;
}
.cell-badge {
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 999px;
    background: #eef2ff;
    color: #4f46e5;
    font-weight: 500;
    white-space: nowrap;
}

.cell-status-list {
    margin-top: 2px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.status-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10px;
}
.status-label {
    flex: 1;
    margin-left: 4px;
    color: #6b7280;
}
.status-count {
    font-weight: 600;
    color: #111827;
    margin-left: 4px;
}

.status-dot {
    width: 9px;
    height: 9px;
    border-radius: 999px;
    display: inline-block;
    margin-bottom: 2px;
}
.status-todo { background: red; }
.status-doing { background: #FFD602;}
.status-done { background: #22c55e; }

/* SIDE PANEL */
.side-panel {
    background: #ffffff;
    border-radius: 20px;
    padding: 16px 18px 12px;
    display: flex;
    flex-direction: column;
    min-height: 260px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}
.side-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
}

.side-stats {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    margin: 8px 0 10px;
}
.stat-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    padding: 8px 10px;
}
.stat-label {
    font-size: 11px;
    color: #6b7280;
    display: flex;
    align-items: center;
    gap: 4px;
}
.stat-number {
    margin-top: 4px;
    font-size: 16px;
    font-weight: 700;
    color: #111827;
}

/* TASK LIST */
.task-list {
    flex: 1;
    overflow-y: auto;
    padding-right: 4px;
    margin-bottom: 8px;
}
.task-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 8px 6px;
    border-radius: 10px;
}
.task-item:hover {
    background: #f3f4ff;
}
.task-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.task-title {
    font-size: 13px;
    font-weight: 500;
    color: #111827;
}
.task-meta {
    font-size: 11px;
    color: #6b7280;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}
.task-status-tag {
    margin-left: 8px;
}

.empty-state {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 13px;
    color: #6b7280;
}

.side-footer {
    margin-top: 8px;
    border-radius: 14px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: #ffffff;
    font-size: 12px;
    text-align: center;
    padding: 10px 8px;
}

/deep/ .el-calendar__title {
    display: none;
}

/deep/ .el-calendar__header {
    justify-content: end;
}


@media (max-width: 1024px) {
    .dialog-footer{
        margin-top: 50px;
    }

    .task-calendar-page {
        padding: 8px;
        gap: 8px;
    }

    .page-content {
        display: block; /* 1 cột cho nhẹ */
    }

    .calendar-card,
    .side-panel {
        width: 100%;
        padding: 8px;
        border-radius: 12px;
        box-shadow: none; /* bỏ shadow cho nhẹ */
        margin-bottom: 8px;
        order: 0 !important;
    }

    /* Thu nhỏ calendar */
    /deep/ .el-calendar {
        font-size: 12px;
    }

    .my-cal-title {
        display: none;
    }

    /deep/ .el-calendar__header {
        padding: 0 4px 6px;
    }

    /deep/ .el-calendar__body {
        padding: 0;
    }

    /deep/ .el-calendar-table td {
        padding: 0;
    }

    /deep/ .el-calendar-table .el-calendar-day {
        height: 54px !important;
        padding: 0 1px;
    }

    .calendar-cell {
        min-height: 44px;
        padding: 3px;
        border-radius: 6px;
        gap: 2px;
    }

    .cell-date {
        font-size: 11px;
    }

    .cell-badge {
        font-size: 9px;
        padding: 0 4px;
    }

    /* Trong ô chỉ để dot + số cho gọn, ẩn label */
    .cell-status-list {
        margin-top: 2px;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 2px 4px;
    }

    .status-item {
        font-size: 9px;
        justify-content: flex-start;
    }

    .status-label {
        display: none;
    }

    .status-count {
        margin-left: 3px;
    }

    /* Side panel text nhỏ lại */
    .side-title {
        font-size: 14px;
    }
    .stat-card {
        padding: 6px 8px;
    }
    .stat-label {
        font-size: 11px;
    }
    .stat-number {
        font-size: 14px;
    }
    .task-title {
        font-size: 12px;
    }
    .task-meta {
        font-size: 10px;
    }
    .side-footer {
        font-size: 11px;
        padding: 8px 6px;
    }

    /* Dialogs trên mobile */
    /deep/ .responsive .el-dialog {
        width: 95% !important;
        max-width: 95vw !important;
    }

    /deep/ .task-detail-dialog {
        max-width: 95vw !important;
        width: 95% !important;
    }

    /deep/ .task-detail-dialog .el-dialog__body {
        max-height: 60vh;
    }

    .cell-status-list {
        display: none;
    }

    /deep/ .el-calendar__header {
        display: none;
    }

    .cell-header {
        display: block;
    }

    .cell-badge {
        font-size: 7px;
    }
}
</style>

<style>
#js-page-content.task-calendar-main-bg .breadcrumb > li > a,
#js-page-content.task-calendar-main-bg .subheader-title,
#js-page-content.task-calendar-main-bg .text-muted,
#js-page-content.task-calendar-main-bg .breadcrumb {
    color: white !important;
    font-weight: 400;
}
#js-page-content i.subheader-icon.far.fa-user {
    color: white !important;
    font-weight: 200;
}


#js-page-content.task-calendar-main-bg {
    background-image: url("../../../../src/assets/img/background/cd98b55b-ffbb-4833-99bd-691fe99bfd15.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>

